/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type IngredientRecipeModal_allUnitMeasure$ref: FragmentReference;
declare export opaque type IngredientRecipeModal_allUnitMeasure$fragmentType: IngredientRecipeModal_allUnitMeasure$ref;
export type IngredientRecipeModal_allUnitMeasure = {|
  +edges: $ReadOnlyArray<?{|
    +node: ?{|
      +description: string,
      +code: string,
      +id: string,
    |}
  |}>,
  +$refType: IngredientRecipeModal_allUnitMeasure$ref,
|};
export type IngredientRecipeModal_allUnitMeasure$data = IngredientRecipeModal_allUnitMeasure;
export type IngredientRecipeModal_allUnitMeasure$key = {
  +$data?: IngredientRecipeModal_allUnitMeasure$data,
  +$fragmentRefs: IngredientRecipeModal_allUnitMeasure$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IngredientRecipeModal_allUnitMeasure",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "UnitMeasureNodeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "UnitMeasureNode",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "description",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "code",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "UnitMeasureNodeConnection"
};
// prettier-ignore
(node/*: any*/).hash = '8e2d1a9d24e3a11095184fa69536c664';

module.exports = node;
